import React, { FunctionComponent, useLayoutEffect, useRef } from "react";

import { useThrottleResizeObserver } from "@multiweb/reactUtils";

export type MeasureCellProps = {
    /** Pošle naměřenou šířku */
    onWidthChange?: (size: number | undefined) => void;
    /** Pošle naměřenou výšku */
    onHeightChange?: (size: number | undefined) => void;
    /** Čas v ms, ve kterém se onSizeCallback zavolá maximálně jednou */
    wait?: number;
};

/**
 * Komponenta sloužící k zjištění rozměrů svého (pozicí) relativního rodiče
 */
export const MeasureCell: FunctionComponent<MeasureCellProps> = ({
    onWidthChange,
    onHeightChange,
    wait = 0,
}) => {
    const ref = useRef<HTMLDivElement>(null);

    useLayoutEffect(() => {
        if (ref?.current) {
            onWidthChange && onWidthChange(ref?.current.clientWidth);
            onHeightChange && onHeightChange(ref?.current.clientHeight);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [onWidthChange, onHeightChange]);

    useThrottleResizeObserver(ref, onWidthChange, onHeightChange, wait);

    return (<div {...{ ref }} style={{ width: "100%", position: "absolute", visibility: "hidden" }} aria-hidden={true}></div>);
};
